import React, { useState } from 'react';
import { Send, TrendingUp, TrendingDown, BarChart2, Star, ChevronRight, Zap } from 'lucide-react';

const AI_QUICK = [
  'Mutasd a top 3-at',
  'Új építésű otthonok',
  'Hitel kalkuláció',
  'Befektetési tippek',
];

const MARKET_DATA = {
  city: 'Budapest átlag (m²)',
  price: '1 215 000 Ft',
  change: '+8,2%',
  positive: true,
  periods: ['1H', '3H', '6H', '1ÉV'],
};

const PRIME_PERKS = [
  'AI asszisztens, ami értéd dolgozik',
  'Valós idejű piaci adatok és elemzések',
  'Átlátható, biztonságos folyamat',
  'Országos kínálat egy helyen',
  'Személyre szabott ajánlatok neked',
];

export default function RightPanel() {
  const [aiInput, setAiInput] = useState('');
  const [activePeriod, setActivePeriod] = useState('1ÉV');
  const [messages, setMessages] = useState([
    {
      from: 'ai',
      text: 'Szia! 👋\nTaláltan 27 ingatlant, ami megfelel a keresésednek. A legjobb ajánlat 12%-kal a piaci ár alatt van.',
    },
  ]);

  const handleSend = () => {
    if (!aiInput.trim()) return;
    setMessages((prev) => [...prev, { from: 'user', text: aiInput }]);
    setAiInput('');
    setTimeout(() => {
      setMessages((prev) => [
        ...prev,
        {
          from: 'ai',
          text: 'Keresem a legjobb ajánlatokat a megadott feltételek alapján… Egy pillanat! 🔍',
        },
      ]);
    }, 800);
  };

  return (
    <aside className="hidden xl:flex flex-col w-[280px] flex-shrink-0 h-full overflow-y-auto gap-4 py-4 px-3">
      
      {/* AI Asszisztens */}
      <div className="bg-[#161616] border border-white/[0.07] rounded-2xl overflow-hidden">
        <div className="flex items-center justify-between px-4 pt-4 pb-3 border-b border-white/[0.06]">
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-[#e31937] to-[#cc1530] flex items-center justify-center">
              <Zap size={13} className="text-white" />
            </div>
            <span className="text-white font-bold text-sm">AI Asszisztens</span>
          </div>
          <span className="text-[10px] font-bold bg-[#e31937]/20 text-[#e31937] px-2 py-0.5 rounded-full border border-[#e31937]/30">
            BÉTA
          </span>
        </div>

        {/* Messages */}
        <div className="px-4 py-3 space-y-3 max-h-40 overflow-y-auto">
          {messages.map((msg, i) => (
            <div
              key={i}
              className={`flex ${msg.from === 'user' ? 'justify-end' : 'items-start gap-2'}`}
            >
              {msg.from === 'ai' && (
                <div className="w-6 h-6 rounded-full bg-gradient-to-br from-[#e31937] to-[#cc1530] flex items-center justify-center flex-shrink-0 mt-0.5">
                  <Zap size={11} className="text-white" />
                </div>
              )}
              <div
                className={`text-xs leading-relaxed rounded-xl px-3 py-2 max-w-[85%] whitespace-pre-line ${
                  msg.from === 'ai'
                    ? 'bg-white/[0.05] text-[#e5e7eb]'
                    : 'bg-[#e31937] text-white'
                }`}
              >
                {msg.text}
              </div>
            </div>
          ))}
        </div>

        {/* Quick actions */}
        <div className="px-4 pb-3 grid grid-cols-2 gap-1.5">
          {AI_QUICK.map((q) => (
            <button
              key={q}
              onClick={() => setAiInput(q)}
              className="text-[10px] text-[#9ca3af] hover:text-white bg-white/[0.04] hover:bg-white/[0.08] border border-white/[0.06] hover:border-[#e31937]/30 rounded-lg px-2 py-1.5 transition-all text-left leading-tight"
            >
              {q}
            </button>
          ))}
        </div>

        {/* Input */}
        <div className="px-3 pb-3">
          <div className="flex items-center gap-2 bg-white/[0.04] border border-white/[0.08] rounded-xl px-3 py-2">
            <input
              value={aiInput}
              onChange={(e) => setAiInput(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleSend()}
              placeholder="Kérdezz bármit az ingatlanokról…"
              className="flex-1 bg-transparent text-xs text-white placeholder-[#6b7280] outline-none"
            />
            <button
              onClick={handleSend}
              className="w-6 h-6 bg-[#e31937] hover:bg-[#cc1530] rounded-lg flex items-center justify-center transition-colors flex-shrink-0"
            >
              <Send size={11} className="text-white" />
            </button>
          </div>
        </div>
      </div>

      {/* Piaci trendek */}
      <div className="bg-[#161616] border border-white/[0.07] rounded-2xl p-4">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <BarChart2 size={15} className="text-[#e31937]" />
            <span className="text-white font-bold text-sm">Piaci trendek</span>
          </div>
          <button className="text-[10px] text-[#e31937] hover:text-white transition-colors flex items-center gap-0.5">
            Részletes jelentés
            <ChevronRight size={11} />
          </button>
        </div>

        <p className="text-[#9ca3af] text-[11px] mb-1">{MARKET_DATA.city}</p>
        <div className="flex items-baseline gap-2 mb-1">
          <span className="text-white font-black text-xl">{MARKET_DATA.price}</span>
        </div>
        <div className={`flex items-center gap-1 mb-4 text-xs font-bold ${MARKET_DATA.positive ? 'text-[#22c55e]' : 'text-[#ef4444]'}`}>
          {MARKET_DATA.positive ? <TrendingUp size={13} /> : <TrendingDown size={13} />}
          {MARKET_DATA.change} az előző negyedévhez képest
        </div>

        {/* Fake sparkline */}
        <div className="h-14 w-full mb-3 relative">
          <svg viewBox="0 0 240 56" className="w-full h-full" preserveAspectRatio="none">
            <defs>
              <linearGradient id="chartGrad" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#e31937" stopOpacity="0.3" />
                <stop offset="100%" stopColor="#e31937" stopOpacity="0" />
              </linearGradient>
            </defs>
            <path
              d="M0,40 C20,38 40,32 60,28 C80,24 100,30 120,22 C140,14 160,18 180,12 C200,6 220,10 240,8"
              fill="none"
              stroke="#e31937"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M0,40 C20,38 40,32 60,28 C80,24 100,30 120,22 C140,14 160,18 180,12 C200,6 220,10 240,8 L240,56 L0,56 Z"
              fill="url(#chartGrad)"
            />
          </svg>
        </div>

        <div className="flex gap-1">
          {MARKET_DATA.periods.map((p) => (
            <button
              key={p}
              onClick={() => setActivePeriod(p)}
              className={`flex-1 text-[10px] font-bold py-1 rounded-lg transition-all ${
                activePeriod === p
                  ? 'bg-[#e31937] text-white'
                  : 'bg-white/[0.04] text-[#6b7280] hover:text-white hover:bg-white/[0.08]'
              }`}
            >
              {p}
            </button>
          ))}
        </div>
      </div>

      {/* HH Prime */}
      <div className="bg-gradient-to-br from-[#1a0a0d] to-[#0f0f0f] border border-[#e31937]/20 rounded-2xl p-4">
        <div className="flex items-center gap-2 mb-3">
          <Star size={14} className="text-[#e31937]" />
          <span className="text-white font-black text-sm">HH PRIME</span>
        </div>
        <p className="text-[#9ca3af] text-[11px] mb-3 leading-relaxed">
          Fedezd fel az exkluzív, off-market ingatlanokat elsőként.
        </p>
        <button className="w-full bg-[#e31937] hover:bg-[#cc1530] text-white text-xs font-bold py-2 rounded-xl transition-colors mb-3 shadow-lg shadow-red-900/20">
          Fedezem
        </button>
        <div className="space-y-1.5">
          {PRIME_PERKS.map((perk) => (
            <div key={perk} className="flex items-center gap-2 text-[10px] text-[#9ca3af]">
              <span className="text-[#e31937] flex-shrink-0">✓</span>
              {perk}
            </div>
          ))}
        </div>
      </div>
    </aside>
  );
}
